import { BlogApiResponse, BlogPost } from "../types/blog";

const API_BASE_URL = 'https://api.eon.health/blog/api/posts/';

export const blogService = {
  // Fetch all blog posts with optional page parameter
  async getAllPosts(page: number = 1): Promise<BlogApiResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}?page=${page}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  // Fetch a single blog post by slug
  async getPostBySlug(slug: string): Promise<BlogPost | null> {
    try {
      const response = await fetch(`${API_BASE_URL}${slug}/`);
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching blog post:', error);
      throw error;
    }
  }
};